var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRUD',{attrs:{"title":"Bank-Account","path":this.path,"fields":this.fields,"width":"500","height":"400"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }